import React from 'react';

const Contact = () => {
    return (
        <div className="font">
            <h2>Contact us</h2>
            <p>Los Angeles - New York
                2860 Michelle Dr. Suite 230
                Irvine, CA 92606

                info@healthcaresuccess.com
                866-639-5049</p>
        </div>
    );
};

export default Contact;